/**
 * Canonical relationship.status values — must match DB chk_relationships_status:
 * Proposed | Approved | Rejected | Deprecated
 */

export const RELATIONSHIP_STATUS_OPTIONS = [
  "Proposed",
  "Approved",
  "Rejected",
  "Deprecated",
];

const ALIASES = {
  Implemented: "Approved",
  Active: "Approved",
  Pending: "Proposed",
};

export function normalizeRelationshipStatus(status, defaultStatus = "Proposed") {
  const raw = String(status ?? defaultStatus ?? "Proposed").trim();
  if (!raw) return defaultStatus || "Proposed";
  const mapped = ALIASES[raw] || raw;
  if (!RELATIONSHIP_STATUS_OPTIONS.includes(mapped)) {
    return defaultStatus || "Proposed";
  }
  return mapped;
}

export function relationshipStatusBadgeClass(status) {
  const value = normalizeRelationshipStatus(status);
  if (value === "Approved") return "bg-green-600 text-white";
  if (value === "Proposed") return "bg-yellow-600 text-white";
  if (value === "Rejected") return "bg-red-700 text-white";
  if (value === "Deprecated") return "bg-red-600 text-white";
  return "bg-gray-600 text-gray-300";
}
